import { render, staticRenderFns } from "./ConfigAIAssist.vue?vue&type=template&id=11adc316&"
import script from "./ConfigAIAssist.vue?vue&type=script&lang=js&"
export * from "./ConfigAIAssist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports